export default __webpack_public_path__ + "static/media/Preguntas-orange.4c9a3447.svg";